module.exports = __webpack_public_path__ + "static/img/modal_bgvi.b96068d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/modal_bgvi.png
// module id = uerU
// module chunks = 1